import { TransitGroup } from '../enums';
import { Transit } from './frontend-generated-types';

export const isDeparture = (transit: Transit) => transit.generalInfo?.group === TransitGroup.DEPARTURE;

export const isArrival = (transit: Transit) => transit.generalInfo?.group === TransitGroup.ARRIVAL;
